<template>
  <div>
    <section class="ren_sucess" v-if="(info.state == 2 && info.dataType == 1) || (info.dataType == 2 && (info.state == 1 || info.state == 3 || info.state == 4))">
      <div class="one" ref="ones">
        <nav>
          <div class="one-left flexr0c">
            <span class="shu"></span>
            <span>企业信息</span>
          </div>
          <div class="one-right">
            <div v-if="info.dataType == 1 && info.state == 2" @click="modal2 = true">
              <span style="color: #d0021b">已驳回！驳回原因</span>
            </div>
            <div v-if="info.dataType == 2 && info.state == 3" @click="modal2 = true">
              <span style="color: #d0021b">已驳回！驳回原因</span>
            </div>
            <!-- 认证驳回隐藏变更按钮 -->
            <div @click="modal1 = true" v-show="(info.state == 3 && info.dataType == 2) || (info.dataType == 2 && (info.state == 1 || info.state == 4))">
              <span>变更</span>
              <img style="margin-left: 5px" src="../../assets/imgs/qiyeziliao/ziliao4.png" alt="" />
            </div>
            <span>|</span>
            <img @click="clickjt(1)" class="jt" src="../../assets/imgs/qiyeziliao/ziliao5.png" alt="" />
          </div>
          <Modal v-model="modal1" title="提示" @on-ok="ok" class-name="vertical-center-modal">
            <p>变更企业信息提交后，平台需要审核，</p>
            <p>时间约为2-3天</p>
            <p>确定需要变更资料？</p>
          </Modal>
          <Modal v-model="modal2" title="驳回原因" class-name="vertical-center-modal1">
            <p style="text-align: center">{{ info.rejectRemark }}</p>
            <div slot="footer" style="display: none"></div>
          </Modal>
        </nav>
        <!-- 内容 -->
        <div id="con">
          <div class="content">
            <section>
              <div class="name">企业名称</div>
              <div class="input">{{ info.enterpriseName }}</div>
            </section>
            <section>
              <div class="name">所属地区</div>
              <div class="input1">
                <div class="city1">{{ info.orgName }}</div>
                <div class="city2">{{ info.ownerTowName }}</div>
              </div>
            </section>
            <section>
              <div class="name">统一社会信用代码</div>
              <div class="input">{{ info.blNum }}</div>
            </section>
            <section>
              <div class="name">企业性质</div>
              <div class="input">{{ bankType }}</div>
            </section>
            <section>
              <div class="name">注册资金（万元）</div>
              <div class="input">{{ info.regFund }}</div>
            </section>
            <section>
              <div class="name">注册日期</div>
              <div class="input">{{ info.regDate }}</div>
            </section>
          </div>
          <div class="content2">
            <div class="name">企业地址</div>
            <div class="input">{{ info.address }}</div>
          </div>
          <div class="content">
            <section>
              <div class="name">开户行</div>
              <div class="input">{{ bankName }}</div>
            </section>
            <section>
              <div class="name">银行账号</div>
              <div class="input">{{ info.bankAccount }}</div>
            </section>
            <section>
              <div class="name">中原银行商户号</div>
              <div class="input">{{ info.zybankMerId }}</div>
            </section>
            <section>
              <div class="name">邮编</div>
              <div class="input">{{ info.postalCode }}</div>
            </section>
          </div>
          <div class="content">
            <section>
              <div class="name">传真</div>
              <div class="input">{{ info.fax }}</div>
            </section>
            <section>
              <div class="name">邮箱</div>
              <div class="input">{{ info.ext2 }}</div>
            </section>
          </div>
          <div class="content2">
            <div class="name">企业网址</div>
            <div class="input">{{ info.enterpriseWeb }}</div>
          </div>
          <div class="content3">
            <div class="name">企业简介</div>
            <div class="input">{{ info.enterpriseProfile }}</div>
          </div>
        </div>
      </div>
      <div class="two">
        <nav>
          <div class="one-left flexr0c">
            <span class="shu"> </span>
            <span>产销信息</span>
          </div>
          <div class="one-right">
            <img @click="clickjt(2)" class="jt2" src="../../assets/imgs/qiyeziliao/ziliao5.png" alt="" />
          </div>
        </nav>

        <div class="con2">
          <div class="content1">
            <div class="top">
              <span>经营类型</span>
              <Checkbox-group v-model="fruit">
                <Checkbox label="开采" disabled></Checkbox>
                <Checkbox label="加工" disabled></Checkbox>
                <Checkbox label="经营" disabled></Checkbox>
              </Checkbox-group>
            </div>
            <div class="box">
              <div class="table">
                <Table border stripe :columns="tableHead" :data="tableData"></Table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- three -->
      <div class="threess">
        <nav>
          <div class="one-left flexr0c">
            <span class="shu"></span>
            <span>联系人信息</span>
          </div>
          <div class="one-right">
            <!-- <div @click="modal1 = true">
              <span>变更</span>
              <img src="../../assets/imgs/qiyeziliao/ziliao4.png" alt="">
            </div> -->
            <!-- <span>|</span> -->
            <img @click="clickjt(3)" class="jt3" src="../../assets/imgs/qiyeziliao/ziliao5.png" alt="" />
          </div>
        </nav>

        <div class="first firstTop">
          <section>
            <div class="first-top">联系人姓名</div>
            <div class="first-bottom">{{ info.cpName }}</div>
          </section>
          <section>
            <div class="first-top">联系人电话</div>
            <div class="first-bottom">{{ info.cpPhone }}</div>
          </section>
        </div>
        <div class="first">
          <section>
            <div class="first-top">联系人身份证号</div>
            <div class="first-bottom">{{ info.cpCardId }}</div>
          </section>
        </div>
        <div class="first">
          <section>
            <div class="first-top">法人姓名</div>
            <div class="first-bottom">{{ info.lpName }}</div>
          </section>
          <section>
            <div class="first-top">法人电话</div>
            <div class="first-bottom">{{ info.lpPhone }}</div>
          </section>
        </div>
        <div class="first">
          <section>
            <div class="first-top">法人身份证号</div>
            <div class="first-bottom">{{ info.lpCardId }}</div>
          </section>
        </div>
        <div class="dashed-line"></div>
        <div class="second">
          <section>
            <div class="sec">联系人身份证正面</div>
            <div class="div flexccc">
              <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!info.cpCardFrontImg" />
              <img :src="fileCommonUrl + info.cpCardFrontImg" alt="" @click="goBig(fileCommonUrl + info.cpCardFrontImg)" v-else />
            </div>
          </section>
          <section>
            <div class="sec">联系人身份证反面</div>
            <div class="div flexccc">
              <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!info.cpCardRearImg" />
              <img :src="fileCommonUrl + info.cpCardRearImg" alt="" @click="goBig(fileCommonUrl + info.cpCardRearImg)" v-else />
            </div>
          </section>
          <section>
            <div class="sec">法人身份证正面</div>
            <div class="div flexccc">
              <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!info.lpCardFrontImg" />
              <img :src="fileCommonUrl + info.lpCardFrontImg" alt="" @click="goBig(fileCommonUrl + info.lpCardFrontImg)" v-else />
            </div>
          </section>
          <section>
            <div class="sec">法人身份证反面</div>
            <div class="div flexccc">
              <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!info.lpCardRearImg" />
              <img :src="fileCommonUrl + info.lpCardRearImg" alt="" @click="goBig(fileCommonUrl + info.lpCardRearImg)" v-else />
            </div>
          </section>
          <section>
            <div class="sec">企业营业执照</div>
            <div class="div flexccc">
              <img src="../../assets/imgs/qiyeziliao/noImg.png" alt="" v-if="!info.trcImg" />
              <img :src="fileCommonUrl + info.trcImg" alt="" @click="goBig(fileCommonUrl + info.trcImg)" v-else />
            </div>
          </section>
        </div>
      </div>
    </section>
    <div class="noCertified flexccc" v-if="info.dataType == 1 && info.state == -2">
      <p class="title">当前用户还未通过企业认证</p>
      <div class="flex-align-center stepBox">
        <div class="step flex-align-center">
          <p class="num">1</p>
          <span>提交资料</span>
        </div>
        <div class="line"></div>
        <div class="step flex-align-center">
          <p class="num">2</p>
          <span>资质审核</span>
        </div>
        <div class="line"></div>
        <div class="step flex-align-center">
          <p class="num">3</p>
          <span>认证成功</span>
        </div>
      </div>
      <div class="certifiedBut">
        <router-link :to="{ path: '/authentication' }">认证企业资料</router-link>
      </div>
      <img src="../../assets/imgs/home/noCertified.png" alt class="noCertifiedImg" />
    </div>
    <authenRenz v-if="info.dataType == 1 && info.state == 0"></authenRenz>
    <authenTijiao v-if="info.dataType == 1 && info.state == -1"></authenTijiao>
    <authenBiangeng v-if="info.dataType == 2 && info.state == 0"></authenBiangeng>
    <!-- <renzReturn v-if="info.dataType == 1 && info.state== 2"></renzReturn> -->
    <!-- <biangengReturn v-if="info.dataType == 2 && info.state== 3"></biangengReturn> -->

    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
  </div>
</template>

<script>
import authenRenz from './authen_renZ.vue'; //认证审核
import authenBiangeng from './authen_biangeng.vue'; //变更审核
import authenTijiao from './authen_tijiaoZL.vue'; //资料提交等待线下提交资料
// import renzReturn from './renzReturn.vue' //认证驳回
// import biangengReturn from './biangengReturn.vue' //变更驳回
import vueViewer from '../../components/bigImg/Viewer';
export default {
  name: 'qiyeSucess',
  components: {
    authenRenz,
    authenBiangeng,
    authenTijiao,
    // renzReturn,
    // biangengReturn,
    vueViewer
  },
  data() {
    return {
      bigUrl: [],
      isShowBig: false,
      show: true,
      fruit: [],
      modal1: false,
      modal2: false,
      jingying: true,
      info: {},
      comType: [],
      bankType: '',
      session: '',
      fileCommonUrl: '',
      tableHead: [
        {
          title: '经营矿种',
          key: 'oreName',
          // width: 250,
          resizable: true
        },
        {
          title: '开采类型',
          key: 'mineTypeName',
          // width: 250,
          resizable: true
        },
        {
          title: '主要销售方向',
          key: 'saleArea',
          // width: 250,
          resizable: true
        },
        {
          title: '年产销能力(万吨)',
          key: 'yearLyoutPut',
          // width: 170,
          resizable: true
        }
      ],
      bankName: '',
      tableData: []
    };
  },
  methods: {
    ok() {
      localStorage['titleName'] = '变更';
      window.sessionStorage.setItem('from', '企业资料');
      this.$router.push('./authentication');
    },
    clickjt: function(x) {
      if (x == 1) {
        let one = document.querySelector('.one');
        let imgjt = document.querySelector('.jt');
        let con = document.getElementById('con');
        if (one.offsetHeight >= 50) {
          one.style.height = 40 + 'px';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao6.png'));
        } else {
          one.style.height = 908 + 'px';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao5.png'));
        }
      }
      if (x == 2) {
        let one = document.querySelector('.two');
        let imgjt = document.querySelector('.jt2');
        if (one.offsetHeight >= 50) {
          one.style.height = 40 + 'px';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao6.png'));
        } else {
          one.style.height = '100%';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao5.png'));
        }
      }
      if (x == 3) {
        let one = document.querySelector('.threess');
        let imgjt = document.querySelector('.jt3');
        if (one.offsetHeight >= 50) {
          one.style.height = 40 + 'px';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao6.png'));
        } else {
          one.style.height = 1300 + 'px';
          one.style.overflow = 'hidden';
          imgjt.setAttribute('src', require('../../assets/imgs/qiyeziliao/ziliao5.png'));
        }
      }
    },
    getOreList() {
      var session = JSON.parse(localStorage['session']);
      this.$http
        .post({
          sessionId: session.sessionId,
          enterpriseId: session.enterpriseId,
          modeCode: 'NEKPI3BNTyQIj9lRgMmZI9jzmhrp3vjJ'
        })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data;
          } else {
            this.$Message['error']({
              background: true,
              content: res.msg
            });
          }
        });
    },
    getCompanyInfo() {
      let data = {
        sessionId: JSON.parse(localStorage['session']).sessionId,
        modeCode: 'YYpXas9qlSnJWer5Ru21Zm1bV77ZB6cl',
        userId: JSON.parse(localStorage['session']).userId,
        enterpriseId: JSON.parse(localStorage['session']).enterpriseId
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.bankList.forEach((ele) => {
            if (ele.code == res.data.enterpriseInfo.bankId) {
              this.bankName = ele.name;
            }
          });
          this.comType = res.data.enterpriseTypeList;
          this.info = res.data.enterpriseInfo;
          if (res.data.enterpriseInfo.regDate) {
            let time = res.data.enterpriseInfo.regDate.split(' ')[1];
            // 判断是否返回的带有时分秒，有的话截取没有的话直接赋值
            time ? (this.info.regDate = res.data.enterpriseInfo.regDate.split(' ')[0]) : (this.info.regDate = res.data.enterpriseInfo.regDate);
          }
          if (this.info.dataType == 1) {
            this.show = false;
          } else {
            this.show = true;
          }
          let businessTypeName = [];
          let businessType = this.info.businessType;
          if (businessType) {
            businessType = businessType.split(',');
            businessType.forEach((item) => {
              if (item == 0) {
                businessTypeName.push('开采');
                return;
              }
              if (item == 1) {
                businessTypeName.push('加工');
                return;
              }
              if (item == 2) {
                businessTypeName.push('经营');
                return;
              }
            });
          }
          this.fruit = businessTypeName;
          this.comType.forEach((item) => {
            if (item.code == this.info.enterpriseType) {
              this.bankType = item.name;
            }
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    goBig(url) {
      if (this.bigUrl.length != 0) {
        this.bigUrl = [];
      }
      this.bigUrl.push(url);
      this.isShowBig = true;
    }
  },
  created() {
    var session = JSON.parse(localStorage['session']);
    this.session = session;
    this.fileCommonUrl = localStorage.getItem('fileCommonUrl');
    this.getOreList();
    this.getCompanyInfo();
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-modal-content {
  border-radius: 10px;

  .ivu-modal-header {
    text-align: center;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
    border-radius: 10px 10px 0 0;

    .ivu-modal-header-inner {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0.34px;
    }
  }

  .ivu-modal-close .ivu-icon-ios-close {
    color: #fff;
  }

  .ivu-modal-body {
    box-sizing: border-box;
    padding: 60px 104px 60px 104px;

    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #4a4a4a;
      letter-spacing: 0;
    }
  }

  .ivu-modal-footer {
    background: #f5f5f5;
    border-radius: 0 0 10px 10px;
    padding: 10px 94px;
    height: 50px;

    .ivu-btn-text {
      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #f5f5f5 100%);
      border: 1px solid #cacaca;
      border-radius: 4px;
      width: 138px;
      height: 30px;
    }

    .ivu-btn-primary {
      background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
      border: 1px solid #285ed3;
      border-radius: 4px;
      border-radius: 4px;
      width: 138px;
      height: 30px;
    }
  }
}

.ren_sucess {
  width: 980px;
  margin-left: 20px;
  padding-top: 0px !important;

  .one {
    height: 100%;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    box-sizing: border-box;
    padding-bottom: 24px;

    nav {
      height: 40px;
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px 10px 0 0;

      .one-left {
        color: #2c59c3;
        font-weight: 600;
        margin-left: 20px;

        .shu {
          display: inline-block;
          width: 4px;
          height: 14px;
          background-color: #2c59c3;
          margin-right: 6px;
        }
      }

      .one-right {
        cursor: pointer;
        // width: 220px;
        display: flex;
        justify-content: right;
        align-items: center;

        div {
          span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #afb4c0;
            letter-spacing: 0.3px;
          }

          margin-right: 15px;
        }

        .jt {
          margin-right: 10px;
          box-sizing: border-box;
          padding: 10px;
        }
      }
    }

    .content {
      width: 980px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 10px 0;

      // justify-content: space-around;
      section {
        width: 368px;
        height: 100px;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        margin-left: 60px;

        .name {
          margin: 10px 0;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          // line-height: 47px;
          margin-top: 20px;
        }

        .input {
          height: 47px;
          line-height: 47px;
          background: #f5f7fa;
          border-radius: 8px;
          border-radius: 8px;
          box-sizing: border-box;
          padding-left: 20px;
        }

        .input1 {
          height: 47px;
          display: flex;

          .city1 {
            width: 150px;
            line-height: 47px;
            text-align: left;
            background: #f5f7fa;
            border-radius: 8px;
            padding-left: 20px;
          }

          .city2 {
            margin-left: 30px;
            width: 200px;
            line-height: 47px;
            text-align: left;
            background: #f5f7fa;
            border-radius: 8px;
            padding-left: 20px;
          }
        }
      }
    }

    .content2 {
      width: 980px;
      height: 100px;
      display: flex;
      flex-direction: column;
      //   justify-content: space-around;
      margin-left: 60px;

      .name {
        width: 860px;
        // height: 47px;
        margin: 10px 0;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #9097a9;
        letter-spacing: 0.26px;
      }

      .input {
        width: 795px;
        height: 47px;
        line-height: 47px;
        background: #f5f7fa;
        border-radius: 8px;
        border-radius: 8px;
        box-sizing: border-box;
        padding-left: 20px;
      }
    }

    .content3 {
      width: 780px;
      margin-left: 60px;

      .name {
        line-height: 47px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #9097a9;
        letter-spacing: 0.26px;
      }

      .input {
        width: 795px;
        height: 120px;
        background: #f5f7fa;
        border-radius: 8px;
        border-radius: 8px;
        box-sizing: border-box;
        padding-left: 20px;
        padding-top: 10px;
      }
    }
  }

  // two
  .two {
    margin-top: 10px;
    width: 980px;
    // height: 330px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    nav {
      height: 40px;
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px 10px 0 0;

      .one-left {
        color: #2c59c3;
        font-weight: 600;
        margin-left: 20px;

        .shu {
          display: inline-block;
          width: 4px;
          height: 14px;
          background-color: #2c59c3;
          margin-right: 6px;
        }
      }

      .one-right {
        cursor: pointer;

        .jt {
          margin-right: 10px;
          box-sizing: border-box;
          padding: 10px;
        }
      }
    }

    .con2 {
      .content1 {
        .top {
          height: 40px;
          display: flex;
          margin-left: 26px;
          align-items: flex-end;

          span {
            margin-right: 20px;
          }
        }

        .box {
          width: 980px;
          overflow: hidden;

          .table {
            width: 928px;
            margin: 20px 0 20px 26px;
          }

          table {
            margin-left: 20px;
            background-color: #e8ecf4;

            thead {
              tr {
                background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
                border-radius: 30px;

                th {
                  width: calc(928px / 4);
                  height: 40px;
                  color: white;
                  text-align: left;
                  padding-left: 10px;
                  box-sizing: border-box;
                }
              }
            }

            tbody {
              tr {
                height: 40px;

                td {
                  width: calc(928px / 4);
                  height: 40px;
                  padding-left: 10px;
                  box-sizing: border-box;
                  background-color: white;
                }
              }
            }
          }
        }
      }
    }
  }

  .threess {
    width: 980px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 10px;

    nav {
      height: 40px;
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px 10px 0 0;

      .one-left {
        color: #2c59c3;
        font-weight: 600;
        margin-left: 20px;

        .shu {
          display: inline-block;
          width: 4px;
          height: 14px;
          background-color: #2c59c3;
          margin-right: 6px;
        }
      }

      .one-right {
        cursor: pointer;
        // width: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
          span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #afb4c0;
            letter-spacing: 0.3px;
          }
        }

        .jt {
          margin-right: 10px;
          box-sizing: border-box;
          padding: 10px;
        }
      }
    }

    .firstTop {
      margin: 10px 0;
    }

    .first {
      width: 980px;
      display: flex;
      box-sizing: border-box;

      //   padding:10px 0;
      section {
        margin-left: 60px;
        width: 368px;
        height: 100px;
        display: flex;
        // justify-content: space-around;
        flex-direction: column;

        .first-top {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          width: 368px;
          margin: 10px 0;
          //   line-height: 47px;
        }

        .first-bottom {
          width: 368px;
          line-height: 47px;
          background: #f5f7fa;
          border-radius: 8px;
          border-radius: 8px;
          box-sizing: border-box;
          padding-left: 20px;
        }
      }
    }

    .dashed-line {
      height: 1px;
      width: 860px;
      border-bottom: 1px dashed rgba(151, 151, 151, 0.1);
      margin: 20px 60px;
    }

    .second {
      width: 980px;
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 20px;

      section {
        width: 368px;
        height: 257px;
        margin-left: 60px;

        .sec {
          width: 368px;
          line-height: 47px;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
        }

        .div {
          width: 368px;
          height: 210px;
          background: #ffffff;
          border: 1px solid #ccd1dd;
          border-radius: 4px;

          img {
            width: 316px;
            height: 200px;
          }
        }
      }
    }
  }
}

.jt2 {
  margin-right: 10px;
  box-sizing: border-box;
  padding: 10px;
}

.jt3 {
  margin-right: 20px;
}

table > thead > tr > th:nth-of-type(1) {
  border-radius: 10px 0 0 0;
}

table > thead > tr > th:nth-of-type(4) {
  border-radius: 0 10px 0 0;
}

.noCertified {
  color: #c3c3c3;
  width: 980px;
  height: 775px;
  background-color: #fff;
  border-radius: 10px;
  margin-left: 20px;

  .title {
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #abafb7;
    letter-spacing: 0;
    margin: 60px 0 30px 0;
  }

  .stepBox {
    margin: 0 30px;

    .step {
      .num {
        width: 34px;
        height: 34px;
        line-height: 34px;
        border-radius: 50%;
        border: 1px solid #c3c3c3;
        color: #c3c3c3;
        text-align: center;
        margin: 0 5px;
      }

      span {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #9b9b9b;
        letter-spacing: -0.57px;
      }
    }

    .line {
      width: 90px;
      height: 1px;
      margin: 0 10px;
      background: #c3c3c3;
    }
  }

  .certifiedBut {
    background-image: linear-gradient(180deg, #fa7864 0%, #f44334 100%);
    border: 1px solid #f44536;
    box-shadow: 0 3px 6px 0 rgba(244, 67, 52, 0.4);
    border-radius: 4px;
    width: 130px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    letter-spacing: 0.37px;
    margin: 50px 0;
    cursor: pointer;

    & > a {
      color: #ffffff;
    }
  }

  .noCertifiedImg {
    width: 280px;
    height: 330px;
  }
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

/deep/ .vertical-center-modal1 {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }

  .ivu-modal-footer {
    display: none;
  }
}

.noImg {
  width: 316px;
  line-height: 200px;
  text-align: center;
  height: 200px;
  color: #f5f5f5;
  background: #cccccc;
}
</style>
